import React, { useMemo } from "react";
import notes from "../../../../assets/images/notes.svg";
import green from "../../../../assets/images/green.svg";
import red from "../../../../assets/images/red.svg";
import orange from "../../../../assets/images/orange.svg";
import CustomCard from "views/components/common/customcard/CustomCard";
import ClaimAge, { ClaimAgeLegend } from "../components/ClaimAge";
import { computeAverageAgeMs } from "../services/claimAgeUtil";
import { useTranslation } from "react-i18next";

const PageGridView = ({ extrated_data }) => {
  const { t } = useTranslation();

  const avgAgeMs = useMemo(
    () =>
      computeAverageAgeMs(
        (extrated_data || []).map((item) => item.extracted_at_cet)
      ),
    [extrated_data]
  );

  return (
    <>
      <div className="extractpdf-cardcontent ps-0 pt-1 pe-0">
        <div className="claim-age-board-legend d-flex align-items-center justify-content-end mb10 pe-1">
          <ClaimAgeLegend />
        </div>
        <div className="row">
          {extrated_data.map((item) => (
            <div
              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb25"
              key={item.id}
            >
              <CustomCard
                id={item.id}
                dotblack="dot-black"
                imgicon={
                  item.extraction_status === "Good"
                    ? green
                    : item.extraction_status === "invalid_file_format" ||
                      item.extraction_status === "invalid_pet_invoice" ||
                      item.extraction_status === "extraction_issue"
                    ? red
                    : orange
                }
                notes={notes}
                notesimageclass="ms-2"
                notescontent={item.updation_status}
                notesclass={
                  item.updation_status === "not_yet_started"
                    ? "not-started-card"
                    : `${item.updation_status}-span`
                }
                cardtitle="d-inline-flex grid-card-title text-gray-e align-items-center mb3 mt3"
                spanbodycontent={
                  <ClaimAge
                    extractedAt={item.extracted_at_cet}
                    avgAgeMs={avgAgeMs}
                    variant="card"
                  />
                }
                spanclassname="d-inline-flex align-items-center"
                pdfclassname="text-gray-e fs18 my-1 grid-card-pdfname"
                pdfname={item.file_name}
                dateclassname="d-md-inline-flex d-block text-gray-g grid-card-subtitle mt-0 mb-0"
                pagenumberclassname="text-gray-g grid-card-subtitle"
                pagenumber={
                  item.number_of_pages !== null
                    ? item.number_of_pages > 1
                      ? item.number_of_pages + " " + t("pages")
                      : item.number_of_pages + " " + t("page")
                    : null
                }
                recentlyUpdatedBy={item.assigned_user}
                animalAvatar={item.animal_avatar}
                extracted_time={item.last_modified_at_cet}
                version_history={item.version_history}
                sas_excel_link={item.sas_excel_link}
                sas_document_link={item.sas_document_link}
                notes_data={item.notes}
                file_name={item.file_name}
                extraction_status={item.extraction_status}
                recipient={
                  item.general_information
                    ? item.general_information["Policyholder Name"]
                    : ""
                }
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
export default PageGridView;
